import React from "react";
import { useTranslation } from "react-i18next";
import Grid from "~/components-shared/Grid";
import { Text } from "~/components-shared";
import WorkingStyleInsightsFields from "~/forms/WorkingStyleForm/WorkingStyleInsightsFields";
import Markdown from "~/components/Markdown";
import styled from "styled-components";
import InputMarkdownTextAreaControl from "~/components/InputMarkdownTextAreaControl";
const List = styled.ul`
  list-style: none;
`;
const UnorderedList = styled.ul`
  padding-left: 1.3em;
  margin-bottom: 1em;
`;
const ListItem = styled.li`
  list-style: none;
`;
const WorkingStyleInsightsForm = _ref => {
  let {
    control,
    editing,
    workingStyle
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("fieldset", null, editing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    s: {
      mb: 5
    },
    lineHeight: 7,
    display: "block"
  }, t("WorkingStyleInsightsForm.insights")), /*#__PURE__*/React.createElement(InputMarkdownTextAreaControl, {
    name: "insights",
    placeholder: t("WorkingStyleInsightsForm.insightsPlaceholder"),
    control: control,
    s: {
      mb: 7
    }
  })) : /*#__PURE__*/React.createElement(Markdown, {
    display: "block",
    lineHeight: 7,
    fontSize: 4,
    text: workingStyle.insights,
    s: {
      mb: 7
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 6,
    equal: true
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h4",
    fontSize: 4,
    s: {
      mb: 3
    },
    display: "block"
  }, t("WorkingStyleInsightsForm.strengthAreas")), editing ? /*#__PURE__*/React.createElement(WorkingStyleInsightsFields, {
    name: "strengthAreas",
    control: control
  }) : workingStyle.strengthAreas.length ? /*#__PURE__*/React.createElement(List, null, workingStyle.strengthAreas.map(item => /*#__PURE__*/React.createElement(ListItem, {
    key: item
  }, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    text: `- ${item}`,
    components: {
      ul: _ref2 => {
        let {
          node,
          ...props
        } = _ref2;
        return /*#__PURE__*/React.createElement(UnorderedList, props);
      }
    }
  })))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    color: "textSecondary",
    s: {
      ml: 5
    }
  }, t("WorkingStyleInsightsForm.notSet"))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h4",
    fontSize: 4,
    s: {
      mb: 3
    },
    display: "block"
  }, t("WorkingStyleInsightsForm.growthAreas")), editing ? /*#__PURE__*/React.createElement(WorkingStyleInsightsFields, {
    name: "growthAreas",
    control: control
  }) : workingStyle.growthAreas.length ? /*#__PURE__*/React.createElement(List, null, workingStyle.growthAreas.map(item => /*#__PURE__*/React.createElement(ListItem, {
    key: item
  }, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    text: `- ${item}`,
    components: {
      ul: _ref3 => {
        let {
          node,
          ...props
        } = _ref3;
        return /*#__PURE__*/React.createElement(UnorderedList, props);
      }
    }
  })))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    color: "textSecondary",
    s: {
      ml: 5
    }
  }, t("WorkingStyleInsightsForm.notSet"))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h4",
    fontSize: 4,
    s: {
      mb: 3
    },
    display: "block"
  }, t("WorkingStyleInsightsForm.mainValues")), editing ? /*#__PURE__*/React.createElement(WorkingStyleInsightsFields, {
    name: "mainValues",
    control: control
  }) : workingStyle.mainValues.length ? /*#__PURE__*/React.createElement(List, null, workingStyle.mainValues.map(item => /*#__PURE__*/React.createElement(ListItem, {
    key: item
  }, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    text: `- ${item}`,
    components: {
      ul: _ref4 => {
        let {
          node,
          ...props
        } = _ref4;
        return /*#__PURE__*/React.createElement(UnorderedList, props);
      }
    }
  })))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    color: "textSecondary",
    s: {
      ml: 5
    }
  }, t("WorkingStyleInsightsForm.notSet"))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h4",
    fontSize: 4,
    s: {
      mb: 3
    },
    display: "block"
  }, t("WorkingStyleInsightsForm.mainBeliefs")), editing ? /*#__PURE__*/React.createElement(WorkingStyleInsightsFields, {
    name: "mainBeliefs",
    control: control
  }) : workingStyle.mainBeliefs.length ? /*#__PURE__*/React.createElement(List, null, workingStyle.mainBeliefs.map(item => /*#__PURE__*/React.createElement(ListItem, {
    key: item
  }, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    text: `- ${item}`,
    components: {
      ul: _ref5 => {
        let {
          node,
          ...props
        } = _ref5;
        return /*#__PURE__*/React.createElement(UnorderedList, props);
      }
    }
  })))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    color: "textSecondary",
    s: {
      ml: 5
    }
  }, t("WorkingStyleInsightsForm.notSet")))));
};
export default WorkingStyleInsightsForm;